import React from "react"
import Images from "../../../components/Images/Images"

import imageMobile from "../../../../static/assets/images/about_us/home_mobile.png"
import imageTablet from "../../../../static/assets/images/about_us/home_tablet.png"
import imageHome from "../../../../static/assets/images/about_us/home_desktop.png"

const StorytellingQuality = () => {
  return (
    <div>
      <div className="so-storytelling_quality">
        <div className="so-storytelling_quality__text">
          <p>
            <strong>
              Con esto, Calorex logra posicionarse como una marca de desempeño
              global que establece un índice de calidad de primer mundo.
            </strong>
          </p>
        </div>
      </div>
      <div className="container_img_home">
        <Images 
          sources={{
            mb: { url: imageMobile },
            sm: { url: imageTablet },
            md: { url: imageHome },
            lg: { url: imageHome },
            url: imageHome,
          }}
          className="imagen_home"
          alt="Calorex home quality"
        />
      </div>
    </div>
  )
}

export default StorytellingQuality
